exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".max-email-height {\n  max-height: 500px;\n  overflow: auto;\n}\n.email-connection {\n  margin-right: auto;\n  margin-left: 24px;\n  padding-right: 90px;\n  padding-left: 59px;\n  padding-top: 4px;\n  background: red;\n  color: white;\n}\n.template-button {\n  margin-top: -15px;\n}\n.sequence-background {\n  background: #fffd78;\n}\n.cke_editable .projectDataHidden {\n  display: none;\n}\n.active-email-style {\n  background: #f6e7d2;\n}\n", ""]);

// exports
